var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 18.6v-2.1c0-.41.34-.75.75-.75s.75.34.75.75v2.1c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 22.75V21c0-1.52 1.23-2.75 2.75-2.75h6c1.52 0 2.75 1.23 2.75 2.75v1.75H6.4zm10-1.5V21c0-.69-.56-1.25-1.25-1.25h-6c-.69 0-1.25.56-1.25 1.25v.25h8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75h-12z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.86 12.18a.74.74 0 0 1-.12-.79c.34-.78.51-1.61.51-2.48v-3c0-.35-.06-.69-.18-1.05-.01-.03-.02-.07-.03-.11-.03-.15-.04-.3-.04-.44 0-.41.34-.75.75-.75h.6c1.79 0 3.25 1.5 3.25 3.35 0 1.53-.63 3.04-1.72 4.13-.02.02-.08.07-.09.08-.59.49-1.26 1.04-2.16 1.29-.07.02-.13.03-.2.03-.21 0-.42-.09-.57-.26zm1.89-6.27v3c0 .41-.03.8-.09 1.2l.17-.14c.8-.8 1.27-1.92 1.27-3.06 0-.9-.61-1.66-1.42-1.82.05.27.07.55.07.82zM5.35 12.36c-.82-.26-1.59-.74-2.23-1.38C1.97 9.71 1.4 8.32 1.4 6.85c0-1.82 1.43-3.25 3.25-3.25h.65c.25 0 .49.13.63.34.14.21.16.48.06.71-.16.36-.24.77-.24 1.2v3c0 .86.17 1.7.52 2.5.12.27.06.58-.13.8-.15.16-.35.25-.56.25a.62.62 0 0 1-.23-.04zM2.9 6.85c0 1.09.44 2.14 1.31 3.1.04.05.09.09.14.13-.07-.41-.1-.82-.1-1.23v-3c0-.24.02-.48.05-.72-.81.16-1.4.86-1.4 1.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9V6c0-2.62 2.13-4.75 4.75-4.75h6c2.62 0 4.75 2.13 4.75 4.75v3c0 4.27-3.48 7.75-7.75 7.75S4.25 13.27 4.25 9zm1.5-3v3c0 3.45 2.8 6.25 6.25 6.25s6.25-2.8 6.25-6.25V6c0-1.79-1.46-3.25-3.25-3.25H9C7.21 2.75 5.75 4.21 5.75 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCup);
export default __webpack_public_path__ + "static/media/vuesax-outline-cup.f1e02bd2c7046a2748eb6989b06ad56b.svg";
export { ForwardRef as ReactComponent };